import {
  countBulletListsInItineraryItems,
  extractOrganizedTourDailyItinerary,
  normalizeItineraryText,
  splitParagraphIntoRichBlocks,
} from "../../../utils/extractOrganizedTourDailyItinerary";
import { isIncludedChecklistCandidateLine, splitTimelineForOfferTabs } from "./publicOfferSectionClassify";

/**
 * @param {string} text
 */
export function safeParseOrganizedTourItinerary(text) {
  try {
    return extractOrganizedTourDailyItinerary(text);
  } catch (err) {
    if (typeof import.meta !== "undefined" && import.meta.env?.DEV) {
      // eslint-disable-next-line no-console
      console.log("[ORG_TOUR_PUBLIC_RENDER_PARSE_TRACE]", {
        detectedDays: 0,
        detectedSections: 0,
        bulletsCreated: 0,
        fallbackUsed: true,
        parseStrategy: "throw_fallback",
        error: String(err?.message || err),
      });
    }
    const safe = normalizeItineraryText(text);
    const prose = { type: "prose", paragraphs: safe ? [safe] : [] };
    return {
      items: safe ? [prose] : [],
      summaryItems: [],
      timelineItems: safe ? [prose] : [],
      daysDetected: 0,
      sectionsDetected: 0,
      fallbackUsed: true,
      parseStrategy: "throw_fallback",
      bulletsCreated: safe ? countBulletListsInItineraryItems([prose]) : 0,
    };
  }
}

/**
 * parsed צריך לעבור refine (refinePublicOfferParsedModel) לפני הקריאה — ראו OrganizedTourPublicOfferLanding.
 * @param {ReturnType<typeof extractOrganizedTourDailyItinerary>} parsed
 */
export function buildOrganizedTourOfferTabModel(parsed) {
  const { describeItems, itineraryItems } = splitTimelineForOfferTabs(parsed.timelineItems);

  const pickSummary = (key) =>
    (parsed.summaryItems || []).filter((s) => s.type === "section" && s.key === key);

  return {
    describeItems,
    itineraryItems,
    included: pickSummary("included"),
    excluded: pickSummary("excluded"),
    notes: pickSummary("notes"),
  };
}

/**
 * שורות "לא כולל" שנשארו בתוך בלוק כולל אצל ספקים — לא מציגים ברשימת וי ירוק.
 */
function isExcludedHeadingLine(t) {
  return /^\s*לא\s*כולל\b/i.test(t) || /^\s*לא\s*כלול\b/i.test(t);
}

/**
 * Flatten section paragraphs into checklist lines (brochure / תחת תיאור כללי).
 * עוצר לפני כותרת "לא כולל" וחותך פסקאות שממזגות כלול+לא כולל.
 * @param {Array<{ paragraphs?: string[] }>} sections
 */
export function flattenIncludedLinesForSidebar(sections) {
  const lines = [];
  /** @type {boolean} */
  let stopped = false;

  const pushLine = (raw) => {
    if (stopped) return;
    const t = String(raw || "").trim();
    if (!t) return;
    if (isExcludedHeadingLine(t)) {
      stopped = true;
      return;
    }
    if (!isIncludedChecklistCandidateLine(t)) return;
    lines.push(t);
  };

  for (const item of sections || []) {
    if (stopped) break;
    const paras = item.paragraphs || [];
    for (const p of paras) {
      if (stopped) break;
      for (const b of splitParagraphIntoRichBlocks(p)) {
        if (stopped) break;
        if (b.type === "ul") {
          for (const line of b.items) {
            if (stopped) break;
            pushLine(line);
          }
        } else if (b.type === "p") {
          let t = String(b.text || "").trim();
          const cut = t.search(/\sלא\s*כולל\b|\sלא\s*כלול\b/i);
          if (cut >= 0) {
            t = t.slice(0, cut).trim();
            if (t && isIncludedChecklistCandidateLine(t)) pushLine(t);
            stopped = true;
            break;
          }
          if (t) pushLine(t);
        }
      }
    }
  }
  return lines;
}
